import { Alert, AlertTitle, Snackbar, type SnackbarCloseReason } from '@mui/material'

type AlertStatus = {
	visible: boolean
	severity: 'success' | 'error' | 'warning' | 'info'
	title: string
	message: string
	duration: number
}

type AlertDismissableProps = {
	status: AlertStatus
	setStatus: (status: AlertStatus) => void
}

export function AlertDismissable({ status, setStatus }: AlertDismissableProps) {
	// Handles both the automatic timeout and the manual "X" click
	const handleClose = (_event: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
		// Keeps the alert open if the user clicks somewhere else on the page
		if (reason === 'clickaway') return

		// Resets the visible state while preserving the message and severity during transition
		setStatus({
			...status,
			visible: false,
		})
	}

	return (
		<div>
			<Snackbar
				open
				autoHideDuration={status.duration} // Disappears automatically after {duration} seconds
				onClose={handleClose}
				anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // Screen placement
				sx={{ left: '55% !important' }}
			>
				<Alert
					onClose={handleClose} // Adds the manual dismiss button
					severity={status.severity}
					variant="filled"
				>
					{status.title && <AlertTitle>{status.title}</AlertTitle>}
					{status.message}
				</Alert>
			</Snackbar>
		</div>
	)
}
